import { render, staticRenderFns } from "./ComplaintsView.vue?vue&type=template&id=e16ca1d4&scoped=true"
import script from "./ComplaintsView.vue?vue&type=script&lang=js"
export * from "./ComplaintsView.vue?vue&type=script&lang=js"
import style0 from "./ComplaintsView.vue?vue&type=style&index=0&id=e16ca1d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e16ca1d4",
  null
  
)

export default component.exports